type CurrencyType = {
  country: string;
  name: string;
  code: string;
  id: string;
  fullName: string;
  region: string;
};
const CURRENCY_LIST: Array<CurrencyType> = [
  {
    country: "Australia",
    name: "AUSTRALIAN DOLLAR",
    code: "AUD",
    id: "aud:cur",
    fullName: "AUDUSD Spot Exchange Rate - Price of 1 AUD in USD",
    region: "Asia",
  },
  {
    country: "Brazil",
    name: "BRAZIL REAL",
    code: "BRL",
    id: "brl:cur",
    fullName: "USDBRL Spot Exchange Rate - Price of 1 USD in BRL",
    region: "Americas",
  },
  {
    country: "United Kingdom",
    name: "BRITISH POUND",
    code: "GBP",
    id: "gbp:cur",
    fullName: "GBPUSD Spot Exchange Rate - Price of 1 GBP in USD",
    region: "EMEA",
  },
  {
    country: "Canada",
    name: "CANADIAN DOLLAR",
    code: "CAD",
    id: "cad:cur",
    fullName: "USDCAD Spot Exchange Rate - Price of 1 USD in CAD",
    region: "Americas",
  },
  {
    country: "China",
    name: "CHINA RENMINBI",
    code: "CNY",
    id: "cny:cur",
    fullName: "USDCNY Spot Exchange Rate - Price of 1 USD in CNY",
    region: "Asia",
  },
  {
    country: "Colombia",
    name: "COLOMBIAN PESO",
    code: "COP",
    id: "cop:cur",
    fullName: "USDCOP Spot Exchange Rate - Price of 1 USD in COP",
    region: "Americas",
  },
  {
    country: "Czech Republic",
    name: "CZECH KORUNA",
    code: "CZK",
    id: "czk:cur",
    fullName: "USDCZK Spot Exchange Rate - Price of 1 USD in CZK",
    region: "EMEA",
  },
  {
    country: "Denmark",
    name: "DANISH KRONE",
    code: "DKK",
    id: "dkk:cur",
    fullName: "USDDKK Spot Exchange Rate - Price of 1 USD in DKK",
    region: "EMEA",
  },
  {
    country: "Europe",
    name: "EURO",
    code: "EUR",
    id: "eur:cur",
    fullName: "EURUSD Spot Exchange Rate - Price of 1 EUR in USD",
    region: "EMEA",
  },
  {
    country: "Hong Kong",
    name: "HONG KONG DOLLAR",
    code: "HKD",
    id: "hkd:cur",
    fullName: "USDHKD Spot Exchange Rate - Price of 1 USD in HKD",
    region: "Asia",
  },
  {
    country: "Hungary",
    name: "HUNGARIAN FORINT",
    code: "HUF",
    id: "huf:cur",
    fullName: "USDHUF Spot Exchange Rate - Price of 1 USD in HUF",
    region: "EMEA",
  },
  {
    country: "India",
    name: "INDIAN RUPEE",
    code: "INR",
    id: "inr:cur",
    fullName: "USDINR Spot Exchange Rate - Price of 1 USD in INR",
    region: "Asia",
  },
  {
    country: "Indonesia",
    name: "INDONESIAN RUPIAH",
    code: "IDR",
    id: "idr:cur",
    fullName: "USDIDR Spot Exchange Rate - Price of 1 USD in IDR",
    region: "Asia",
  },
  {
    country: "Israel",
    name: "ISRAELI SHEKEL",
    code: "ILS",
    id: "ils:cur",
    fullName: "USDILS Spot Exchange Rate - Price of 1 USD in ILS",
    region: "EMEA",
  },
  {
    country: "Japan",
    name: "JAPANESE YEN",
    code: "JPY",
    id: "jpy:cur",
    fullName: "USDJPY Spot Exchange Rate - Price of 1 USD in JPY",
    region: "Asia",
  },
  {
    country: "Malaysia",
    name: "MALAYSIAN RINGGIT",
    code: "MYR",
    id: "myr:cur",
    fullName: "USDMYR Spot Exchange Rate - Price of 1 USD in MYR",
    region: "Asia",
  },
  {
    country: "Mexico",
    name: "MEXICAN PESO",
    code: "MXN",
    id: "mxn:cur",
    fullName: "USDMXN Spot Exchange Rate - Price of 1 USD in MXN",
    region: "Americas",
  },
  {
    country: "New Zealand",
    name: "NEW ZEALAND DOLLAR",
    code: "NZD",
    id: "nzd:cur",
    fullName: "NZDUSD Spot Exchange Rate - Price of 1 NZD in USD",
    region: "Asia",
  },
  {
    country: "Norway",
    name: "NORWEGIAN KRONE",
    code: "NOK",
    id: "nok:cur",
    fullName: "USDNOK Spot Exchange Rate - Price of 1 USD in NOK",
    region: "EMEA",
  },
  {
    country: "Philippines",
    name: "PHILIPPINES PESO",
    code: "PHP",
    id: "php:cur",
    fullName: "USDPHP Spot Exchange Rate - Price of 1 USD in PHP",
    region: "Asia",
  },
  {
    country: "Poland",
    name: "POLISH ZLOTY",
    code: "PLN",
    id: "pln:cur",
    fullName: "USDPLN Spot Exchange Rate - Price of 1 USD in PLN",
    region: "EMEA",
  },
  {
    country: "Russia",
    name: "RUSSIAN RUBLE",
    code: "RUB",
    id: "rub:cur",
    fullName: "USDRUB Spot T+1 (TOM) Exchange Rate - Price of 1 USD in RUB",
    region: "EMEA",
  },
  {
    country: "Singapore",
    name: "SINGAPORE DOLLAR",
    code: "SGD",
    id: "sgd:cur",
    fullName: "USDSGD Spot Exchange Rate - Price of 1 USD in SGD",
    region: "Asia",
  },
  {
    country: "South Africa",
    name: "SOUTH AFRICAN RAND",
    code: "ZAR",
    id: "zar:cur",
    fullName: "USDZAR Spot Exchange Rate - Price of 1 USD in ZAR",
    region: "EMEA",
  },
  {
    country: "South Korea",
    name: "SOUTH KOREAN WON",
    code: "KRW",
    id: "krw:cur",
    fullName: "USDKRW Spot Exchange Rate - Price of 1 USD in KRW",
    region: "Asia",
  },
  {
    country: "Sweden",
    name: "SWEDISH KRONA",
    code: "SEK",
    id: "sek:cur",
    fullName: "USDSEK Spot Exchange Rate - Price of 1 USD in SEK",
    region: "EMEA",
  },
  {
    country: "Switzerland",
    name: "SWISS FRANC",
    code: "CHF",
    id: "chf:cur",
    fullName: "USDCHF Spot Exchange Rate - Price of 1 USD in CHF",
    region: "EMEA",
  },
  {
    country: "Taiwan",
    name: "TAIWAN DOLLAR",
    code: "TWD",
    id: "twd:cur",
    fullName: "USDTWD Spot Exchange Rate - Price of 1 USD in TWD",
    region: "Asia",
  },
  {
    country: "Thailand",
    name: "THAI BAHT",
    code: "THB",
    id: "thb:cur",
    fullName: "USDTHB Spot Exchange Rate - Price of 1 USD in THB",
    region: "Asia",
  },
  {
    country: "Turkey",
    name: "TURKISH LIRA",
    code: "TRY",
    id: "try:cur",
    fullName: "USDTRY Spot Exchange Rate - Price of 1 USD in TRY",
    region: "EMEA",
  },
  {
    country: "United Arab Emirates",
    name: "UAE DIRHAM",
    code: "AED",
    id: "aed:cur",
    fullName: "USDAED Spot Exchange Rate - Price of 1 USD in AED",
    region: "EMEA",
  },
  {
    country: "United States",
    name: "US DOLLAR",
    code: "USD",
    id: "usd:cur",
    fullName: "USDUSD Spot Exchange Rate - Price of 1 USD in USD",
    region: "Americas",
  },
];

export const CURRENCY_DROPDOWN_OPTIONS = CURRENCY_LIST.map((item) => ({
  displayName: item.code,
  value: item.code,
}));

export default CURRENCY_LIST;
